export default "__VITE_ASSET__BmeZl3Y6__"